// /src/components/BrandList.tsx
import React, { } from 'react';
import { Brand } from '../utils/types';

interface BrandListProps {
    brands: Brand[];
    onSelectBrand: (brand: Brand) => void;
    selectedBrands: Brand[];
}

const BrandList: React.FC<BrandListProps> = ({ brands, onSelectBrand, selectedBrands }) => {
    const sortedBrands = [...brands].sort((a, b) => a.cat_name.localeCompare(b.cat_name));

    return (
        <ul
            className={`fixed top-10 md:top-10 left-0 z-50 bg-purple-100 w-11/12 md:w-3/4 overflow-y-scroll h-[100vh] text-[0.8em] md:text-[1em] mt-0 ml-0 pl-2 pt-2 pb-36
                ${sortedBrands.length > 30 ? 'grid grid-cols-3 gap-x-1' : ''}`}
        >
            {sortedBrands.map(brand => {
                const isSelected = selectedBrands.some(b => b.id === brand.id);
                return (
                    <li key={brand.id} className={`border-b border-b-1 border-b-gray-200 
                            ${isSelected ? 'bg-purple-200 py-1 font-semibold text-blue-600 shadow-lg' : ''}`}>
                        <button onClick={() => onSelectBrand(brand)} className="w-full text-left break-words m-0 px-0 py-1   hover:bg-purple-300 hover:rounded hover:underline hover:underline-offset-8 decoration-purple-400">
                            {brand.cat_name}&nbsp;
                            <span className="text-xs text-gray-400">({brand.brand_prod_qty})</span>
                        </button>
                    </li>
                );
            })}
        </ul>
    );
};

export default BrandList;
